<template lang="pug">
  .gvl-input-data
    v-expansion-panels(v-model="panel" accordion tile multiple)
      v-expansion-panel
        v-expansion-panel-header Angaben zur Antragstellerin bzw. dem Antragsteller
        v-expansion-panel-content(eager)
          applicant-information(ref="applicant-info")

      v-expansion-panel
        v-expansion-panel-header Bankverbindung
        v-expansion-panel-content(eager)
          bank-details(ref="bank-details")

      v-expansion-panel
        v-expansion-panel-header Angaben zur Förderberechtigung
        v-expansion-panel-content(eager)
          funding-information(ref="funding-info")

      v-expansion-panel
        v-expansion-panel-header Künstlerisches Konzept
        v-expansion-panel-content(eager)
          artistic-concept(ref="artistic-concept")

    //p.hint-label.mt-10 Hinweis: Nach Betätigung des Buttons wird automatisch geprüft, ob alle Pflichtangaben gemacht wurden. Ist Ihr Antrag vollständig, erhalten Sie eine Übersicht aller getätigter Daten und Uploads, die Sie vor dem Senden noch einmal prüfen und ausdrucken können.

    v-btn.mt-5(color="primary" block @click="onCheckInfo") Angaben prüfen

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    ApplicantInformation: () => import('@/components/applicant-information'),
    BankDetails: () => import('@/components/bank-details'),
    FundingInformation: () => import('@/components/funding-information'),
    ArtisticConcept: () => import('@/components/artistic-concept'),
  }
})
export default class InputData extends Vue {
  panel = []

  onCheckInfo () {
    const accordions = [
      'applicant-info',
      'bank-details',
      'funding-info',
      'artistic-concept'
    ]

    let errorField = null

    accordions.forEach((ref, index) => {
      let errorField_ = this.$refs[ref].firstErrorField
      if (errorField_ && !errorField) {
        errorField = errorField_

        if (!this.panel.includes(index)) {
          this.panel.push(index)
          this.panel = [
            ...this.panel
          ]
        }
      }
    })

    if (errorField) {
      setTimeout(() => {
        const header = document.getElementById('header-logos')
        const offset = header ? header.clientHeight : 0
        // console.log(header.clientHeight, this.getElementTop(errorField.$el))

        window.scrollTo({
          top: this.getElementTop(errorField.$el) - (offset + 50),
          behavior: 'smooth'
        })

        if (errorField.type === 'text') {
          errorField.focus()
        }
      }, 300)
      return
    }

    this.$emit('next')
  }
}
</script>
